/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { anonymizeCompany } from '../fn/company/anonymize-company';
import { AnonymizeCompany$Params } from '../fn/company/anonymize-company';
import { CompanyCto } from '../models/company-cto';
import { CompanyRules } from '../models/company-rules';
import { CompanyUpgradeDetailsCto } from '../models/company-upgrade-details-cto';
import { DetailedCompanyCto } from '../models/detailed-company-cto';
import { executeCompanyUpgrade } from '../fn/company/execute-company-upgrade';
import { ExecuteCompanyUpgrade$Params } from '../fn/company/execute-company-upgrade';
import { extendCompanyTimeTrial$Json } from '../fn/company/extend-company-time-trial-json';
import { ExtendCompanyTimeTrial$Json$Params } from '../fn/company/extend-company-time-trial-json';
import { extendCompanyTimeTrial$Plain } from '../fn/company/extend-company-time-trial-plain';
import { ExtendCompanyTimeTrial$Plain$Params } from '../fn/company/extend-company-time-trial-plain';
import { FolderCto } from '../models/folder-cto';
import { getCompanies$Json } from '../fn/company/get-companies-json';
import { GetCompanies$Json$Params } from '../fn/company/get-companies-json';
import { getCompanies$Plain } from '../fn/company/get-companies-plain';
import { GetCompanies$Plain$Params } from '../fn/company/get-companies-plain';
import { getCompany$Json } from '../fn/company/get-company-json';
import { GetCompany$Json$Params } from '../fn/company/get-company-json';
import { getCompany$Plain } from '../fn/company/get-company-plain';
import { GetCompany$Plain$Params } from '../fn/company/get-company-plain';
import { getCompanyEmployeeAccessRules$Json } from '../fn/company/get-company-employee-access-rules-json';
import { GetCompanyEmployeeAccessRules$Json$Params } from '../fn/company/get-company-employee-access-rules-json';
import { getCompanyEmployeeAccessRules$Plain } from '../fn/company/get-company-employee-access-rules-plain';
import { GetCompanyEmployeeAccessRules$Plain$Params } from '../fn/company/get-company-employee-access-rules-plain';
import { getCompanyFolders$Json } from '../fn/company/get-company-folders-json';
import { GetCompanyFolders$Json$Params } from '../fn/company/get-company-folders-json';
import { getCompanyFolders$Plain } from '../fn/company/get-company-folders-plain';
import { GetCompanyFolders$Plain$Params } from '../fn/company/get-company-folders-plain';
import { getCompanyTimeTrial$Json } from '../fn/company/get-company-time-trial-json';
import { GetCompanyTimeTrial$Json$Params } from '../fn/company/get-company-time-trial-json';
import { getCompanyTimeTrial$Plain } from '../fn/company/get-company-time-trial-plain';
import { GetCompanyTimeTrial$Plain$Params } from '../fn/company/get-company-time-trial-plain';
import { getCompanyUpgradeDetails$Json } from '../fn/company/get-company-upgrade-details-json';
import { GetCompanyUpgradeDetails$Json$Params } from '../fn/company/get-company-upgrade-details-json';
import { getCompanyUpgradeDetails$Plain } from '../fn/company/get-company-upgrade-details-plain';
import { GetCompanyUpgradeDetails$Plain$Params } from '../fn/company/get-company-upgrade-details-plain';
import { getExplainUserAccess$Json } from '../fn/company/get-explain-user-access-json';
import { GetExplainUserAccess$Json$Params } from '../fn/company/get-explain-user-access-json';
import { getExplainUserAccess$Plain } from '../fn/company/get-explain-user-access-plain';
import { GetExplainUserAccess$Plain$Params } from '../fn/company/get-explain-user-access-plain';
import { PersonsAuthorizationCriteriaExplainResult } from '../models/persons-authorization-criteria-explain-result';
import { repairOrgPathAsync$Json } from '../fn/company/repair-org-path-async-json';
import { RepairOrgPathAsync$Json$Params } from '../fn/company/repair-org-path-async-json';
import { repairOrgPathAsync$Plain } from '../fn/company/repair-org-path-async-plain';
import { RepairOrgPathAsync$Plain$Params } from '../fn/company/repair-org-path-async-plain';
import { RepairOrgPathResponse } from '../models/repair-org-path-response';
import { TimeTrialCto } from '../models/time-trial-cto';
import { updateCompany$Json } from '../fn/company/update-company-json';
import { UpdateCompany$Json$Params } from '../fn/company/update-company-json';
import { updateCompany$Plain } from '../fn/company/update-company-plain';
import { UpdateCompany$Plain$Params } from '../fn/company/update-company-plain';
import { updateCompanyEmployeeAccessRules$Json } from '../fn/company/update-company-employee-access-rules-json';
import { UpdateCompanyEmployeeAccessRules$Json$Params } from '../fn/company/update-company-employee-access-rules-json';
import { updateCompanyEmployeeAccessRules$Plain } from '../fn/company/update-company-employee-access-rules-plain';
import { UpdateCompanyEmployeeAccessRules$Plain$Params } from '../fn/company/update-company-employee-access-rules-plain';
import { validateOrgPathAsync$Json } from '../fn/company/validate-org-path-async-json';
import { ValidateOrgPathAsync$Json$Params } from '../fn/company/validate-org-path-async-json';
import { validateOrgPathAsync$Plain } from '../fn/company/validate-org-path-async-plain';
import { ValidateOrgPathAsync$Plain$Params } from '../fn/company/validate-org-path-async-plain';

@Injectable({ providedIn: 'root' })
export class CompanyService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `getCompany()` */
  static readonly GetCompanyPath = '/company/{companyId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompany$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompany$Plain$Response(params: GetCompany$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DetailedCompanyCto>> {
    return getCompany$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompany$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompany$Plain(params: GetCompany$Plain$Params, context?: HttpContext): Observable<DetailedCompanyCto> {
    return this.getCompany$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DetailedCompanyCto>): DetailedCompanyCto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompany$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompany$Json$Response(params: GetCompany$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DetailedCompanyCto>> {
    return getCompany$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompany$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompany$Json(params: GetCompany$Json$Params, context?: HttpContext): Observable<DetailedCompanyCto> {
    return this.getCompany$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<DetailedCompanyCto>): DetailedCompanyCto => r.body)
    );
  }

  /** Path part for operation `updateCompany()` */
  static readonly UpdateCompanyPath = '/company/{companyId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCompany$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateCompany$Plain$Response(params: UpdateCompany$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<DetailedCompanyCto>> {
    return updateCompany$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCompany$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateCompany$Plain(params: UpdateCompany$Plain$Params, context?: HttpContext): Observable<DetailedCompanyCto> {
    return this.updateCompany$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<DetailedCompanyCto>): DetailedCompanyCto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCompany$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateCompany$Json$Response(params: UpdateCompany$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<DetailedCompanyCto>> {
    return updateCompany$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCompany$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateCompany$Json(params: UpdateCompany$Json$Params, context?: HttpContext): Observable<DetailedCompanyCto> {
    return this.updateCompany$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<DetailedCompanyCto>): DetailedCompanyCto => r.body)
    );
  }

  /** Path part for operation `getCompanies()` */
  static readonly GetCompaniesPath = '/company/search';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanies$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanies$Plain$Response(params?: GetCompanies$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CompanyCto>>> {
    return getCompanies$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanies$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanies$Plain(params?: GetCompanies$Plain$Params, context?: HttpContext): Observable<Array<CompanyCto>> {
    return this.getCompanies$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CompanyCto>>): Array<CompanyCto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanies$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanies$Json$Response(params?: GetCompanies$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CompanyCto>>> {
    return getCompanies$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanies$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanies$Json(params?: GetCompanies$Json$Params, context?: HttpContext): Observable<Array<CompanyCto>> {
    return this.getCompanies$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CompanyCto>>): Array<CompanyCto> => r.body)
    );
  }

  /** Path part for operation `extendCompanyTimeTrial()` */
  static readonly ExtendCompanyTimeTrialPath = '/company/{companyId}/extendtimetrial';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `extendCompanyTimeTrial$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  extendCompanyTimeTrial$Plain$Response(params: ExtendCompanyTimeTrial$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<TimeTrialCto>> {
    return extendCompanyTimeTrial$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `extendCompanyTimeTrial$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  extendCompanyTimeTrial$Plain(params: ExtendCompanyTimeTrial$Plain$Params, context?: HttpContext): Observable<TimeTrialCto> {
    return this.extendCompanyTimeTrial$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<TimeTrialCto>): TimeTrialCto => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `extendCompanyTimeTrial$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  extendCompanyTimeTrial$Json$Response(params: ExtendCompanyTimeTrial$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TimeTrialCto>> {
    return extendCompanyTimeTrial$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `extendCompanyTimeTrial$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  extendCompanyTimeTrial$Json(params: ExtendCompanyTimeTrial$Json$Params, context?: HttpContext): Observable<TimeTrialCto> {
    return this.extendCompanyTimeTrial$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<TimeTrialCto>): TimeTrialCto => r.body)
    );
  }

  /** Path part for operation `getCompanyTimeTrial()` */
  static readonly GetCompanyTimeTrialPath = '/company/{companyId}/timetrial';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyTimeTrial$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyTimeTrial$Plain$Response(params: GetCompanyTimeTrial$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TimeTrialCto>>> {
    return getCompanyTimeTrial$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyTimeTrial$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyTimeTrial$Plain(params: GetCompanyTimeTrial$Plain$Params, context?: HttpContext): Observable<Array<TimeTrialCto>> {
    return this.getCompanyTimeTrial$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TimeTrialCto>>): Array<TimeTrialCto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyTimeTrial$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyTimeTrial$Json$Response(params: GetCompanyTimeTrial$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<TimeTrialCto>>> {
    return getCompanyTimeTrial$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyTimeTrial$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyTimeTrial$Json(params: GetCompanyTimeTrial$Json$Params, context?: HttpContext): Observable<Array<TimeTrialCto>> {
    return this.getCompanyTimeTrial$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<TimeTrialCto>>): Array<TimeTrialCto> => r.body)
    );
  }

  /** Path part for operation `getCompanyFolders()` */
  static readonly GetCompanyFoldersPath = '/company/{companyId}/folders';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyFolders$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyFolders$Plain$Response(params: GetCompanyFolders$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FolderCto>>> {
    return getCompanyFolders$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyFolders$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyFolders$Plain(params: GetCompanyFolders$Plain$Params, context?: HttpContext): Observable<Array<FolderCto>> {
    return this.getCompanyFolders$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FolderCto>>): Array<FolderCto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyFolders$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyFolders$Json$Response(params: GetCompanyFolders$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<FolderCto>>> {
    return getCompanyFolders$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyFolders$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyFolders$Json(params: GetCompanyFolders$Json$Params, context?: HttpContext): Observable<Array<FolderCto>> {
    return this.getCompanyFolders$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<FolderCto>>): Array<FolderCto> => r.body)
    );
  }

  /** Path part for operation `getCompanyUpgradeDetails()` */
  static readonly GetCompanyUpgradeDetailsPath = '/company/{companyId}/upgrade';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyUpgradeDetails$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyUpgradeDetails$Plain$Response(params: GetCompanyUpgradeDetails$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CompanyUpgradeDetailsCto>>> {
    return getCompanyUpgradeDetails$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyUpgradeDetails$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyUpgradeDetails$Plain(params: GetCompanyUpgradeDetails$Plain$Params, context?: HttpContext): Observable<Array<CompanyUpgradeDetailsCto>> {
    return this.getCompanyUpgradeDetails$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CompanyUpgradeDetailsCto>>): Array<CompanyUpgradeDetailsCto> => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyUpgradeDetails$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyUpgradeDetails$Json$Response(params: GetCompanyUpgradeDetails$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<CompanyUpgradeDetailsCto>>> {
    return getCompanyUpgradeDetails$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyUpgradeDetails$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyUpgradeDetails$Json(params: GetCompanyUpgradeDetails$Json$Params, context?: HttpContext): Observable<Array<CompanyUpgradeDetailsCto>> {
    return this.getCompanyUpgradeDetails$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<Array<CompanyUpgradeDetailsCto>>): Array<CompanyUpgradeDetailsCto> => r.body)
    );
  }

  /** Path part for operation `executeCompanyUpgrade()` */
  static readonly ExecuteCompanyUpgradePath = '/company/{companyId}/upgrade';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `executeCompanyUpgrade()` instead.
   *
   * This method doesn't expect any request body.
   */
  executeCompanyUpgrade$Response(params: ExecuteCompanyUpgrade$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return executeCompanyUpgrade(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `executeCompanyUpgrade$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  executeCompanyUpgrade(params: ExecuteCompanyUpgrade$Params, context?: HttpContext): Observable<void> {
    return this.executeCompanyUpgrade$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getCompanyEmployeeAccessRules()` */
  static readonly GetCompanyEmployeeAccessRulesPath = '/company/{companyId}/rules';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyEmployeeAccessRules$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyEmployeeAccessRules$Plain$Response(params: GetCompanyEmployeeAccessRules$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyRules>> {
    return getCompanyEmployeeAccessRules$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyEmployeeAccessRules$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyEmployeeAccessRules$Plain(params: GetCompanyEmployeeAccessRules$Plain$Params, context?: HttpContext): Observable<CompanyRules> {
    return this.getCompanyEmployeeAccessRules$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompanyRules>): CompanyRules => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getCompanyEmployeeAccessRules$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyEmployeeAccessRules$Json$Response(params: GetCompanyEmployeeAccessRules$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyRules>> {
    return getCompanyEmployeeAccessRules$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getCompanyEmployeeAccessRules$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getCompanyEmployeeAccessRules$Json(params: GetCompanyEmployeeAccessRules$Json$Params, context?: HttpContext): Observable<CompanyRules> {
    return this.getCompanyEmployeeAccessRules$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompanyRules>): CompanyRules => r.body)
    );
  }

  /** Path part for operation `updateCompanyEmployeeAccessRules()` */
  static readonly UpdateCompanyEmployeeAccessRulesPath = '/company/{companyId}/rules';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCompanyEmployeeAccessRules$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateCompanyEmployeeAccessRules$Plain$Response(params: UpdateCompanyEmployeeAccessRules$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyRules>> {
    return updateCompanyEmployeeAccessRules$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCompanyEmployeeAccessRules$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateCompanyEmployeeAccessRules$Plain(params: UpdateCompanyEmployeeAccessRules$Plain$Params, context?: HttpContext): Observable<CompanyRules> {
    return this.updateCompanyEmployeeAccessRules$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompanyRules>): CompanyRules => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateCompanyEmployeeAccessRules$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateCompanyEmployeeAccessRules$Json$Response(params: UpdateCompanyEmployeeAccessRules$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<CompanyRules>> {
    return updateCompanyEmployeeAccessRules$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateCompanyEmployeeAccessRules$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  updateCompanyEmployeeAccessRules$Json(params: UpdateCompanyEmployeeAccessRules$Json$Params, context?: HttpContext): Observable<CompanyRules> {
    return this.updateCompanyEmployeeAccessRules$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<CompanyRules>): CompanyRules => r.body)
    );
  }

  /** Path part for operation `getExplainUserAccess()` */
  static readonly GetExplainUserAccessPath = '/company/{companyId}/explainAccess/{userId}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExplainUserAccess$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExplainUserAccess$Plain$Response(params: GetExplainUserAccess$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<PersonsAuthorizationCriteriaExplainResult>> {
    return getExplainUserAccess$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getExplainUserAccess$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExplainUserAccess$Plain(params: GetExplainUserAccess$Plain$Params, context?: HttpContext): Observable<PersonsAuthorizationCriteriaExplainResult> {
    return this.getExplainUserAccess$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<PersonsAuthorizationCriteriaExplainResult>): PersonsAuthorizationCriteriaExplainResult => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getExplainUserAccess$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExplainUserAccess$Json$Response(params: GetExplainUserAccess$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<PersonsAuthorizationCriteriaExplainResult>> {
    return getExplainUserAccess$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getExplainUserAccess$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getExplainUserAccess$Json(params: GetExplainUserAccess$Json$Params, context?: HttpContext): Observable<PersonsAuthorizationCriteriaExplainResult> {
    return this.getExplainUserAccess$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<PersonsAuthorizationCriteriaExplainResult>): PersonsAuthorizationCriteriaExplainResult => r.body)
    );
  }

  /** Path part for operation `anonymizeCompany()` */
  static readonly AnonymizeCompanyPath = '/company/{companyId}/anonymize';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `anonymizeCompany()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymizeCompany$Response(params: AnonymizeCompany$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return anonymizeCompany(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `anonymizeCompany$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  anonymizeCompany(params: AnonymizeCompany$Params, context?: HttpContext): Observable<void> {
    return this.anonymizeCompany$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `validateOrgPathAsync()` */
  static readonly ValidateOrgPathAsyncPath = '/company/{companyId}/validate-org-path';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `validateOrgPathAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  validateOrgPathAsync$Plain$Response(params: ValidateOrgPathAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<RepairOrgPathResponse>> {
    return validateOrgPathAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `validateOrgPathAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  validateOrgPathAsync$Plain(params: ValidateOrgPathAsync$Plain$Params, context?: HttpContext): Observable<RepairOrgPathResponse> {
    return this.validateOrgPathAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<RepairOrgPathResponse>): RepairOrgPathResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `validateOrgPathAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  validateOrgPathAsync$Json$Response(params: ValidateOrgPathAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<RepairOrgPathResponse>> {
    return validateOrgPathAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `validateOrgPathAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  validateOrgPathAsync$Json(params: ValidateOrgPathAsync$Json$Params, context?: HttpContext): Observable<RepairOrgPathResponse> {
    return this.validateOrgPathAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<RepairOrgPathResponse>): RepairOrgPathResponse => r.body)
    );
  }

  /** Path part for operation `repairOrgPathAsync()` */
  static readonly RepairOrgPathAsyncPath = '/company/{companyId}/repair-org-path';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `repairOrgPathAsync$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  repairOrgPathAsync$Plain$Response(params: RepairOrgPathAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<RepairOrgPathResponse>> {
    return repairOrgPathAsync$Plain(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `repairOrgPathAsync$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  repairOrgPathAsync$Plain(params: RepairOrgPathAsync$Plain$Params, context?: HttpContext): Observable<RepairOrgPathResponse> {
    return this.repairOrgPathAsync$Plain$Response(params, context).pipe(
      map((r: StrictHttpResponse<RepairOrgPathResponse>): RepairOrgPathResponse => r.body)
    );
  }

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `repairOrgPathAsync$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  repairOrgPathAsync$Json$Response(params: RepairOrgPathAsync$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<RepairOrgPathResponse>> {
    return repairOrgPathAsync$Json(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `repairOrgPathAsync$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  repairOrgPathAsync$Json(params: RepairOrgPathAsync$Json$Params, context?: HttpContext): Observable<RepairOrgPathResponse> {
    return this.repairOrgPathAsync$Json$Response(params, context).pipe(
      map((r: StrictHttpResponse<RepairOrgPathResponse>): RepairOrgPathResponse => r.body)
    );
  }

}
